import { getLinkType } from '@/datalayer/App.datalayer.utils';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

export const CARD_CAROUSEL_EVENTS = {
  cardClick: 'trackEvent-cardCarouselCardClick',
  linkClick: 'trackEvent-cardCarouselLinkClick',
  ctaClick: 'trackEvent-cardCarouselCtaClick',
};
export const CARD_CAROUSEL_EVENTS_NAMES = {
  cardClick: 'card_carousel_card_click',
  linkClick: 'card_carousel_link_click',
  ctaClick: 'card_carousel_link_click',
};

export const LIST_CARD_CAROUSEL_EVENTS = {
  cardClick: 'trackEvent-listCardCarouselCardClick',
  ctaClick: 'trackEvent-listCardCarouselCtaClick',
};
export const LIST_CARD_CAROUSEL_EVENTS_NAMES = {
  cardClick: 'list_card_carousel_card_click',
  ctaClick: 'list_card_carousel_link_click',
};

export const onDataLayerCardCarousel =
  ({ event = CARD_CAROUSEL_EVENTS.linkClick, eventName = CARD_CAROUSEL_EVENTS_NAMES.linkClick }) =>
  ({ target }: OnDatalayerProps) => {
    if (!target) return undefined;
    if (target?.closest('[data-datalayer-ignore-card-carousel]')) return undefined;

    const title = (target?.closest('[data-datalayer-card-title]') as HTMLDivElement)?.dataset
      ?.datalayerCardTitle;
    const index = (target?.closest('[data-datalayer-card-index]') as HTMLDivElement)?.dataset
      ?.datalayerCardIndex;
    const href = target?.href || '';
    const type = getLinkType(target);
    const linkText = target?.textContent?.trim();

    return {
      event,
      event_name: eventName,
      link_url: href,
      ...(!!linkText && { link_text: linkText }),
      ...(!!type && { type }),
      ...(!!title && { title }),
      index_num: String(index),
    };
  };
